import ArticleLayout from '@/components/feature/ArticleLayout';
import articleContents from '@/mocks/article-content';

export default function ArticleComeFunziona() {
  return <ArticleLayout article={articleContents['come-funziona-itaobuy']} />;
}